import React, { useEffect } from "react";
import StablePrime from "../components/Tables/StablePrime";
import { useLocation } from "react-router-dom";
import queryString from "query-string";

function LinePerformance({ setPageHeader, urlData }) {
  const { search } = useLocation();
  const searchParams = queryString.parse(search);
 // setPageHeader("Line Performance");


  return (
    <div>
      <StablePrime pageTitle="Line Performance" setPageHeader={setPageHeader} autoUpdate={true} zenTable={true} url="lineperformance" data={{ ...searchParams, ...urlData }} identity="perfparam" />
    </div>
  );
}

export default LinePerformance;
